

























































































































































































































import dayjs from "@/plugins/dayjs";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { AxiosData } from "@/common/http/http";
import { Util, getExcelJSONDataByList, getPageAPIs } from "@/common/util";

import PandaMobileTable from "@/components/mobile-custom/panda-table.vue";

import PandaMobileTWFContainer from "@/components/mobile-custom/panda-table-with-filter-container.vue";

import { IdolMonthIncomeAPI } from "@/common/api/dataWholeBoard/idolMonthIncome";
import { excuteDownloadExport2Excel } from "@/common/xlsx";

function getCurrentMonthDate() {
  const currentDay = (dayjs() as any).format("YYYY-MM");

  const curMonthStartDay = (dayjs().startOf("month") as any).format("YYYY-MM");

  return [curMonthStartDay, currentDay];
}

function getLastMonthDate() {
  const lastEndDay = (dayjs().startOf("month") as any).format("YYYY-MM");

  const lastStartDay = (
    dayjs().subtract(1, "month").endOf("month") as any
  ).format("YYYY-MM");

  return [lastStartDay, lastEndDay];
}

// console.log(getLastMonthDate(), 'getLastMonthDate')
export const pageApiList = getPageAPIs(IdolMonthIncomeAPI);

@Component({
  components: {
    PandaMobileTable,
    PandaMobileTWFContainer,
  },
  filters: {
    // getTodayTotalIncome(row: any) {
    // }
  },
})
export default class MerchantsAudit extends Vue {
  /** 移动端相关属性 方法 */
  private allMobileChooseFields: any[] = [
    {
      label: "日期",
      field: "date",
    },
    {
      label: "总营业额",
      field: "gmv",
    },
    {
      label: "最终收益",
      field: "merchant_income",
    },
    {
      label: "开房时长(h)",
      field: "open_duration",
    },
    {
      label: "订单量",
      field: "order_num",
    },
    {
      label: "赠送优惠券时长",
      field: "shop_give_coupon_duration",
    },
    {
      label: "免费开房时长",
      field: "free_open_duration",
    },
    {
      label: "单店卡充值",
      field: "shop_member_price",
    },
    {
      label: "赠送单店卡",
      field: "give_shop_member_price",
    },
    {
      label: "单店卡消费",
      field: "shop_member_consume",
    },
    {
      label: "平台券使用时长",
      field: "platform_coupon_duration",
    },
    {
      label: "商品销售",
      field: "commodity_order",
    },
    {
      label: "全国会员充值金额",
      field: "member_recharge",
    },
    {
      label: "全国会员消费金额",
      field: "member_consume",
    },
    {
      label: "微信支付",
      field: "wechat_pay",
    },
    {
      label: "优惠券",
      field: "voucher_income",
    },
    {
      label: "美团券核销金额",
      field: "meituan_price",
    },
    {
      label: "抖音券核销金额",
      field: "douyin_price",
    },
  ];
  /** end 移动端相关属性 方法 */

  private idolMonthIncomeApi: any;

  constructor() {
    super();
    this.idolMonthIncomeApi = new IdolMonthIncomeAPI();
  }

  private form: any = {
    // shop_name: '',
    time: [...getLastMonthDate()],
  };

  private pickerOptions: any = {
    shortcuts: [
      // {
      //   text: '本月',
      //   onClick(picker: any) {

      //     picker.$emit('pick', getCurrentMonthDate());
      //   }
      // },
      {
        text: "上月",
        onClick(picker: any) {
          picker.$emit("pick", getLastMonthDate());
        },
      },
    ],
  };

  private tableData: any[] = [];

  private tablePage: any = {
    totalCount: 0,
    pageNo: 1,
    pageSize: 10,
    pageSizes: [10, 20, 50, 100, 200, 500],
  };

  private activated(): void {
    // if (this.$route.query.name) {
    //   this.form.shop_name = this.$route.query.name;
    // }
    this.search();
  }

  private getTable(): void {
    this.idolMonthIncomeApi.monthBusiness(
      {
        ...this.getMonthIncomeAuditTableListParams(),
      },
      (res: any) => {
        this.tableData = res.data.list;
        this.tablePage.totalCount = res.data.count;
      }
    );
  }

  /** 导出excel */
  private downloadExcelLoading: boolean = false;

  // 商户字段名 文案对应关系
  private monthIncomeExcelList2ch: any = {
    date: "日期",
    gmv: "总营业额",
    merchant_income: "最终收益",
    open_duration: "开房时长(h)",
    order_num: "订单量",
    shop_give_coupon_duration: "赠送优惠券时长",
    free_open_duration: "免费开房时长",
    shop_member_price: "单店卡充值",
    give_shop_member_price : "赠送单店卡",
    shop_member_consume: "单店卡消费",
    platform_coupon_duration: "平台券使用时长",
    commodity_order: "商品销售",
    member_recharge: "全国会员充值金额",
    member_consume: "全国会员消费金额",
    wechat_pay: "微信支付",
    voucher_income: "优惠券",
    meituan_price: "美团券核销金额",
    douyin_price: "抖音券核销金额"
  };
  // 商户Excel 表头的先后顺序
  private monthIncomeExcelSortList: string[] = [
    "date",
    "gmv",
    "merchant_income",
    "open_duration",
    "order_num",
    "shop_give_coupon_duration",
    "free_open_duration",
    "shop_member_price",
    "give_shop_member_price",
    "shop_member_consume",
    "platform_coupon_duration",
    "commodity_order",
    "member_recharge",
    "member_consume",
    "wechat_pay",
    "voucher_income",
    "meituan_price",
    "douyin_price"
  ];

  private getMonthIncomeAuditTableListParams(mode = "all") {
    // mode 可选的值 all  noPageOption exportExcel
    const form = this.form;

    const tablePage = this.tablePage;

    const {
      // shop_name, // 店铺名称

      time,
    } = form || {};

    // console.log(technicianItem, "technicianItem");

    const { pageNo, pageSize } = tablePage || {};

    const outerParams: any = {};

    // if (shop_name) {
    //   outerParams.shop_name = shop_name;
    // }

    if (Array.isArray(time) && time.length === 2) {
      const [start_month, end_month] = time;

      outerParams.start_month = start_month;

      outerParams.end_month = end_month;
    }

    if (
      mode == "exportExcel" &&
      !(outerParams.start_month && outerParams.end_month)
    ) {
      this.$message.error("请选择创建时段导出数据");
      return null;
    }

    if (mode === "all") {
      outerParams.page = pageNo;

      outerParams.limit = pageSize;
    } else if (mode == "exportExcel") {
      // outerParams.is_export = 1
    }

    console.log(outerParams, "outerParams");

    return outerParams;
  }

  // 点击导出excel 表格
  private handleExportExcelMonthIncomeAuditList() {
    this.getTable();
    const params: any = this.getMonthIncomeAuditTableListParams("exportExcel");

    if (params === null) {
      return false;
    }

    this.downloadExcelLoading = true;
    this.idolMonthIncomeApi.exportExcelMonthIncomeAuditList(
      params,
      (res: any) => {
        const { start_month, end_month } = params || {};

        const filename = `大明星每月营收列表 ${start_month}到${end_month}.xlsx`;
        const { data } = res || {};

        const { list: originList } = data || {};

        const newList = Array.isArray(originList)
          ? originList.map((item) => {
              const { orderNum } = item || {};
              const newItem = {
                ...(item || {}),
              };

              const exculdeKeys = ["date"];

              for (const key in item) {
                if (exculdeKeys.includes(key)) continue;
                newItem[key] = Number(item[key]);
              }

              return newItem;
            })
          : [];

        if (newList.length > 0) {
          const monthIncomeExcelSortList = this.monthIncomeExcelSortList;

          const monthIncomeExcelList2ch = this.monthIncomeExcelList2ch;

          const excelJSONData = getExcelJSONDataByList(
            newList,
            monthIncomeExcelSortList,
            monthIncomeExcelList2ch
          );

          console.log(excelJSONData, "excelJSONData");

          excuteDownloadExport2Excel(excelJSONData, filename);
        } else {
          this.$message.info("选中时段没有可导出的信息");
        }

        // const testData = [
        //   { 主页: "test1223424", 名称: "6800", 数量: "6800", 昵称: "广告主网" },
        //   { 主页: "433", 名称: "6800", 数量: "6800", 昵称: "广告主网" },
        //   { 名称: "22", 商家: "6800", 数量: "6800", 昵称: "广告主网", },
        //   { 名称: "43", 商家: "6800", 数量: "6800", 昵称: "广告主网", },
        //   { 店家: "43", 价格: "6800", 数量: "6800", 昵称: "广告主网", }
        // ]

        this.downloadExcelLoading = false;
      },
      () => {
        this.downloadExcelLoading = false;
      }
    );
  }

  /** end 导出excel */

  private restForm(): void {
    this.form = new Util().clearObject(this.form);

    this.getTable();
  }

  private search(): void {
    this.tablePage.pageNo = 1;
    this.tableData = [];
    this.tablePage.totalCount = 0;

    this.getTable();
  }

  private handlePageChange(val: any) {
    this.tablePage.pageNo = val.currentPage;
    this.tablePage.pageSize = val.pageSize;

    this.getTable();
  }

  private exportTable() {
    // new HealthWarning().exportTable(this.form);
  }
}
